import React from 'react';
import {
  Alert,
  Snackbar,
  Box,
  Typography,
  Button
} from '@mui/material';
import {
  Restore as RestoreIcon,
  Close as CloseIcon
} from '@mui/icons-material';

function CartRestoreNotification({ open, onClose, cartCount }) {
  if (cartCount === 0) return null;

  return (
    <Snackbar
      open={open}
      autoHideDuration={8000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={onClose}
        severity="info"
        icon={<RestoreIcon />}
        sx={{ 
          width: '100%',
          maxWidth: 400,
          '& .MuiAlert-message': {
            width: '100%'
          }
        }}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={onClose}
            startIcon={<CloseIcon />}
          >
            Dismiss
          </Button>
        }
      >
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
            Cart Restored
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Your cart with {cartCount} item{cartCount !== 1 ? 's' : ''} has been restored from your previous session.
          </Typography>
        </Box>
      </Alert>
    </Snackbar>
  );
}

export default CartRestoreNotification;